import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextLayoutComponent } from './text-layout.component';
import { TextModule } from '../text/text.module';

@NgModule({
  declarations: [
    TextLayoutComponent
  ],
  imports: [
    CommonModule,
    TextModule
  ],
  exports: [
    TextLayoutComponent
  ]
})
export class TextLayoutModule { }
